import {
  AiOutlineMail,
  AiOutlineGithub,
  // AiOutlineInstagram,
} from "react-icons/ai";
import { FaXTwitter } from "react-icons/fa6";
import { SiLinktree } from "react-icons/si";

export const contact = [
  {
    icon: <AiOutlineMail />,
    name: "Email",
    link: "mailto:oluwatobiss@codesweetly.com",
  },
  {
    icon: <FaXTwitter />,
    name: "X (Twitter)",
    link: "https://twitter.com/oluwatobiss",
  },
  {
    icon: <AiOutlineGithub />,
    name: "GitHub",
    link: "https://github.com/oluwatobiss",
  },
  {
    icon: <SiLinktree />,
    name: "Linktree",
    link: "https://linktr.ee/oluwatobiss",
  },
  // {
  //   icon: <AiOutlineInstagram />,
  //   name: "Instagram",
  //   link: "https://www.instagram.com/codesweetly",
  // },
];
